import { render, staticRenderFns } from "./RepopulateReadonlyFields.vue?vue&type=template&id=4fb6e08e&"
import script from "./RepopulateReadonlyFields.vue?vue&type=script&lang=js&"
export * from "./RepopulateReadonlyFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports